import { isEqual, isPlainObject } from 'lodash';

export const getSettingsPatch = (previous, next) => {
  const keys = new Set([...Object.keys(previous || {}), ...Object.keys(next || {})]);

  return [...keys].reduce((patch, key) => {
    const before = previous?.[key];
    const after = next?.[key];

    if (isPlainObject(before) && isPlainObject(after)) {
      const nested = getSettingsPatch(before, after);
      if (Object.keys(nested).length > 0) patch[key] = nested;
    } else if (!isEqual(before, after)) {
      patch[key] = after === undefined ? null : after;
    }

    return patch;
  }, {});
};

export const applySettingsPatch = (settings, patch) => {
  if (patch === undefined) return settings;
  if (!isPlainObject(settings) || !isPlainObject(patch)) return patch;

  return Object.entries(patch).reduce(
    (merged, [key, value]) => ({ ...merged, [key]: applySettingsPatch(settings[key], value) }),
    { ...settings }
  );
};
